<div class="form" [formGroup]="childForm">
  <mat-slider min="18" max="99" discrete>
    <input formControlName="minAgeCtrl" matSliderStartThumb>
    <input formControlName="maxAgeCtrl" matSliderEndThumb>
  </mat-slider>
</div>
